import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getPatientsByStatus } from "@/Services/TherapyApi/Clients";
import PatientTransformer from "@/Modules/Transformers/Patients/Patient";

import usePatientsStore from "@/Modules/Patients/Store";
import useAppStore from "@/Modules/App/Store";

async function filterPatientsByStatusAH(status: string): Promise<boolean> {
  const patientsStore = usePatientsStore();
  const appStore = useAppStore();

  patientsStore.isLoading = patientsStore.isFiltering = true;

  try {
    const patients = await getPatientsByStatus(status);

    patientsStore.patients = PatientTransformer.toRecord(patients);

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    patientsStore.isLoading = false;
  }
}

export default filterPatientsByStatusAH;
